var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"color-font-load text-center"},[_vm._v(" myGOD Dashboard "),_c('br'),_vm._v(" Please Use the Search Panels Above to Define Graph Parameters ")])])
}]

export { render, staticRenderFns }